import axios from "axios";
import { adminAPI } from "../utils/apiStrings";

export default class Admin {
  static exportTransactions = async (queryString) => {
    try {
      const response = await axios.get(
        `${adminAPI()}/export-transaction${queryString}`,
        { responseType: "blob" },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  static getTransactions = async (params) => {
    try {
      const response = await axios.get(`${adminAPI()}/transaction-report`, {
        params,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  static getTotalSales = async (params) => {
    try {
      const response = await axios.get(`${adminAPI()}/total-sales`, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  };
}
